//
//
//
//
//
//

export default {
    name: "Row",

    props: {
        // Whether the row's columns shall retrieve a tight spacing
        tight: {
            type: Boolean,
            default: false,
        },

        // Whether the row's columns shall retrieve no spacing
        plain: {
            type: Boolean,
            default: false,
        },

        // A breakpoint at which and above to reverse the direction of the row's columns
        reverse: {
            type: String,
            default: null,
        },
    },

    computed: {
        reverseStyle() {
            switch (this.reverse) {
                case 'sm':
                    return 'sm:row-reverse';
                case 'md':
                    return 'md:row-reverse';
                case 'lg':
                    return 'lg:row-reverse';
                case 'xl':
                    return 'xl:row-reverse';
            }
            return null;
        }
    }
}
